// components/common/EnamadWidget/EnamadWidget.jsx
import React, { useEffect, useRef } from "react";
import "./EnamadWidget.css";

const EnamadWidget = () => {
  const enamadRef = useRef(null);

  useEffect(() => {
    // تابع باز کردن پنجره اینماد
    const handleEnamadClick = (e) => {
      e.preventDefault();
      window.open(
        "https://trustseal.enamad.ir/?id=385160&Code=CTDn5KsaHUcqrnRPVKn59TLPggOwzwHE",
        "Popup",
        "toolbar=no, scrollbars=no, location=no, statusbar=no, menubar=no, resizable=0, width=450, height=630, top=30",
      );
    };

    const enamadElement = enamadRef.current;
    if (enamadElement) {
      enamadElement.addEventListener("click", handleEnamadClick);
    }

    return () => {
      if (enamadElement) {
        enamadElement.removeEventListener("click", handleEnamadClick);
      }
    };
  }, []);

  return (
    <div className="enamad-widget" ref={enamadRef}>
      <img
        src="/img/enamad.png"
        alt="نماد اعتماد الکترونیکی"
        width="80"
        height="88"
        className="enamad-image"
      />
    </div>
  );
};

export default EnamadWidget;
